import Card from "./Card";
import {
  IndustriesWeEmpowerContent,
  KeyFeaturesOfIOTTechnologyContent,
} from "./data";
import { motion } from "framer-motion";

export const KeyFeaturesCard = () => {
  return (
    <section className="container space-y-28 px-5 md:px-10">
      <div className="space-y-10">
        <div className="space-y-5 mx-auto md:w-11/12 lg:w-10/12 xl:w-8/12   ">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] text-center  font-bold text-dark font-butler"
          >
            Industries we empower with IoT{" "}
          </motion.h2>
          <p className="text-base leading-[1.625rem] text-center text-dark ">
              {IndustriesWeEmpowerContent.description}
          </p>
        </div>

        <div className="flex flex-wrap  gap-x-6 gap-y-8 justify-center">
          {IndustriesWeEmpowerContent.List.map((list, index) => {
            return (
              <Card
                key={index}
                index={index}
                heading={list.heading}
                text={list.text}
                img={list.img}
                colorScheme={["#erer", "#df"]}
              />
            );
          })}
        </div>
      </div>
      <div className="space-y-10">
        <div className="space-y-5 mx-auto md:w-11/12 lg:w-10/12 xl:w-8/12   ">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] text-center  font-bold text-dark font-butler"
          >
            Key Features of IoT Technology{" "}
          </motion.h2>
          <p className="text-base leading-[1.625rem] text-center text-dark ">
            {KeyFeaturesOfIOTTechnologyContent.description}
          </p>
        </div>

        <div className="flex flex-wrap  gap-x-6 gap-y-8 justify-center">
          {KeyFeaturesOfIOTTechnologyContent.List.map((list, index) => {
            return (
              <Card
                key={index}
                index={index}
                heading={list.heading}
                text={list.text}

                colorScheme={["#erer", "#df"]}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};
